import { Icon } from "@design-system/Icon";
import { Button } from "@design-system/Inputs/Button";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { Text } from "@design-system/Typography/Text";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "../../i18n";

type DittoGuidanceSelectorProps = {
    onEnterGuidance: () => void;
};

export const DittoGuidanceSelector: React.FC<DittoGuidanceSelectorProps> = ({
    onEnterGuidance,
}) => {
    const { t } = useTranslation(RESOURCE_NAME);

    return (
        <FlexRow alignItems="start" className="bg-neutral-100" p="4">
            <FlexCol justifyContent="between" w="full" gap="2">
                <FlexRow alignItems="center" gap="2" justifyContent="between">
                    <FlexRow alignItems="center" gap="2">
                        <Icon name="ecoVadis" className="w-7 h-7" />
                        <Text variant="body-lg-bold">
                            {t(keys.ditto_guidance_title)}
                        </Text>
                    </FlexRow>

                    <Button
                        variant="outlined"
                        size="sm"
                        onClick={onEnterGuidance}
                    >
                        {t(keys.ditto_guidance_button)}
                    </Button>
                </FlexRow>
                <FlexRow
                    alignItems="center"
                    justifyContent="between"
                    gap="2"
                    w="full"
                >
                    <Text variant="body-sm">
                        {t(keys.ditto_guidance_subtitle)}
                    </Text>
                </FlexRow>
            </FlexCol>
        </FlexRow>
    );
};
